module.exports = __webpack_public_path__ + "media/images/people_database-6ac8aab4b2b544babf47b8cc6935d3b5.jpg";